(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!customElements.get('laley-collection-discovery')) {
    customElements.define('laley-collection-discovery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        const activate = (index, focus = false) => {
          tabs.forEach((tab, at) => {
            tab.setAttribute('aria-selected', String(at === index));
            tab.tabIndex = at === index ? 0 : -1;
          });
          panels.forEach((panel, at) => { panel.hidden = at !== index; });
          if (focus) tabs[index].focus();
        };
        activate(0);
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(index), { signal: this.controller.signal });
          tab.addEventListener('keydown', (event) => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            activate(next, true);
          }, { signal: this.controller.signal });
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
